








































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { required } from 'vuelidate/lib/validators';
import { CommonUtils } from '@/util/commonUtils';

@Component({
    props: {
        paymentCustomerId: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            paymentSourceId: '',
        };
    },
    validations: {
        paymentSourceId: {
            required,
        },
    },
})

export default class AddLocationModal extends Vue {
    private show = true;
    private paymentSources: [] = [];

    public mounted() {
        this.getListPaymentSource('card');
    }

    private async getListPaymentSource(paymentMethod: 'bank_account' | 'card') {
        const response = await ObjectFactory.getPaymentSourceService().getListPaymentSource(paymentMethod,
            this.$store.state.serverUrl, this.$props.paymentCustomerId);
        this.paymentSources = response.data;
    }

    private async setPrimaryPaymentSource() {
        const response = await ObjectFactory.getPaymentSourceService().
            setDefaultPaymentSource(this.$data.paymentSourceId, this.$store.state.serverUrl,
            this.$props.paymentCustomerId);
        if (response.success) {
            this.$emit('close');
            this.$emit('success');
        } else {
            CommonUtils.showError(response);
        }
    }

    private close() {
        this.$emit('close');
    }
}
